export type BuildInfo = {
  version: string
  sha: string
  branch: string
  dirty: boolean
  commitAt: string
  builtAt: string
}

declare const __BUILD__: BuildInfo

export const BUILD: BuildInfo = __BUILD__

/** "v0.2.0 · a1b2c3d" — or with a trailing * when built from a dirty tree. */
export const shortLabel = () =>
  `v${BUILD.version} · ${BUILD.sha}${BUILD.dirty ? '*' : ''}`

export const buildDate = () => {
  const d = new Date(BUILD.builtAt)
  return Number.isNaN(d.valueOf())
    ? BUILD.builtAt
    : d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })
}

// Handy for checking a live tab without opening the UI: BUILD in the console.
if (typeof window !== 'undefined') {
  ;(window as unknown as { BUILD: BuildInfo }).BUILD = BUILD
}
